var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IGetCachedImageUseCaseType } from '../../../Domain/UseCases/Application/GetCachedImageUseCase/IGetCachedImageUseCase';
import { IDownloadImageUseCaseType } from '../../../Domain/UseCases/Application/DownloadImageUseCase/IDownloadImageUseCase';
import { IGetIsDownloadingImageUseCaseType } from '../../../Domain/UseCases/Application/GetIsDownloadingImageUseCase/IGetIsDownloadingImageUseCase';
import { reactive } from '../../Decorators/Reactive';
import { injectable } from '../../../Data/Decorators/Injectable';
import { inject } from '../../../Data/Decorators/Inject';
let CachedImageViewModel = class CachedImageViewModel {
    constructor(getCachedImage, downloadImage, getIsDownloadingImage) {
        this.getCachedImage = getCachedImage;
        this.downloadImage = downloadImage;
        this.getIsDownloadingImage = getIsDownloadingImage;
        this.viewData = {};
        this.getImage = this.getImage.bind(this);
        this.download = this.download.bind(this);
        this.setIsElementVisible = this.setIsElementVisible.bind(this);
        this.getIsDownloading = this.getIsDownloading.bind(this);
    }
    getImage(url) {
        return this.getCachedImage.execute(url);
    }
    getIsDownloading(url) {
        return this.getIsDownloadingImage.execute(url);
    }
    download(url) {
        return this.downloadImage.execute(url);
    }
    setIsElementVisible(val) {
        this.downloadImage.setIsElementVisible(val);
    }
    updateViewData(update) {
        this.viewData = Object.assign(Object.assign({}, this.viewData), update);
    }
};
__decorate([
    reactive(),
    __metadata("design:type", Object)
], CachedImageViewModel.prototype, "viewData", void 0);
CachedImageViewModel = __decorate([
    injectable(),
    __param(0, inject(IGetCachedImageUseCaseType)),
    __param(1, inject(IDownloadImageUseCaseType)),
    __param(2, inject(IGetIsDownloadingImageUseCaseType)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CachedImageViewModel);
export { CachedImageViewModel };
